export enum TipType {
  Fixed = 'FIXED_AMOUNT',
  Perc = 'PERCENTAGE',
}

export interface TipPreset {
  id: number;
  amount: number;
  type: TipType;
}
